export default "__VITE_ASSET__DJIeYnSJ__"